import PublicHeader from "@/components/layout/PublicHeader";
import PublicFooter from "@/components/layout/PublicFooter";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function LegalPage({
  titleKey,
  introKey,
  extra,
  testid,
  hero = "hero-salnes-alt2",
}) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-salnes-ivory" data-testid={testid}>
      <PublicHeader />
      <section className="relative pt-32 pb-16 lg:pb-24 border-b hairline">
        <div className="absolute inset-0 opacity-[0.08]" style={{
          backgroundImage: `url(/brand/${hero}.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }} />
        <div className="relative mx-auto max-w-[1000px] px-6 lg:px-10">
          <div className="text-[11px] uppercase tracking-[0.28em] text-salnes-emerald mb-3">
            {t("common.institutional")}
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-serif text-5xl lg:text-6xl text-salnes-ink leading-[1.02]"
          >
            {t(titleKey)}
          </motion.h1>
          <p className="mt-6 text-lg text-salnes-ink/80 leading-relaxed max-w-2xl">
            {t(introKey)}
          </p>
        </div>
      </section>
      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-[1000px] px-6 lg:px-10 space-y-8 text-salnes-ink/85 leading-relaxed">
          {extra}
          <div className="rounded-xl border hairline bg-salnes-sand/30 p-6 text-sm text-salnes-stone">
            {t("legal.ai_notice")}
          </div>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
